import {
  CONVERSATION_FACTS_MEASURES,
  DRIFT_CHAT_TAGS_DIMENSIONS,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

/**
 * Base cube query for conversation count by tag name.
 */
export const ConversationTagsBaseQuery: CubeQuery = {
  name: 'ConversationTags',
  queryName: 'ConversationTag',
  query: {
    measures: [CONVERSATION_FACTS_MEASURES.CONVERSATION_COUNT],
    dimensions: [DRIFT_CHAT_TAGS_DIMENSIONS.TAG_NAME],
    order: [[CONVERSATION_FACTS_MEASURES.CONVERSATION_COUNT, 'desc']],
  },
}
